<template>
<div
  id="fixMenu"
  :style="{'top': fixCartTop}">
  <div
    v-show="showOverlay && windowW < 768"
    @click="overlay"
    class="LightboxOverlay"></div>
  <div class="imgWrapper"></div>
  <div id="listWrapper">
    <div class="box">
      <h2>選購清單({{cartLen()}})</h2>
      <div
        class="switchBtn"
        v-if="!showOverlay && windowW > 768 && cartList.length > 0"
        @click="shopListSwith"></div>
      <img v-if="cartNoGiftLen == 0" src="../../assets/item-pic-null@2x.png">
      <div v-else>
        <img v-if="cartList[0] && cartList[0].imageurl && cartList[0].ptype != 4" :src="cartList[0].imageurl" alt="">
        <img v-else :src="cartList[1].imageurl" alt="">
      </div>
      <div
        :class="['order',{'emptyCart': cartNoGiftLen == 0}]"
        @click="toCart">結帳</div>
    </div>
    <div
      v-if="showOverlay && shopList"
      id="listContainer">
      <div
        style="background-color:#fff;width:25px;height:136px;right:110px;top:0;position:absolute"
        v-if="windowW > 768"></div>
      <h2 v-if="windowW <= 768">選購清單({{cartLen()}})</h2>
      <div
        class="close"
        @click="overlay"></div>
      <div class="list">
        <div class="productWrapper">
          <productBuy
            :cartList="cartList"
            :pageNow="pageNo"
            v-on:passPageNow="passPageNow"
            v-if="windowW > 768"
            @deleteCart="deleteCart" />
          <productBuyM
            :cartList="cartList"
            v-if="windowW <= 768"
            @deleteCart="deleteCart" />
        </div>
        <div
          class="pagination"
          v-if="windowW > 768 && cartNoGiftLen > 5">
          <button class="preBtn" v-if="pageNo != 1" @click="prevPage"></button>
          {{pageNo}} / {{Math.ceil(cartNoGiftLen/5)}}
          <button class="nextBtn" v-if="pageNo < Math.ceil(cartNoGiftLen/5)" @click="nextPage"></button>
        </div>
      </div>

    </div>
  </div>
  <ul v-if="fixMenuSwitch">
    <li
      v-for="(item,index) in category"
      :key="index"
      @click="goTocatelog(index)"
      :class="{ 'active': selectedIndex == index, 'small': windowW <= 768}">{{item.name}}</li>
  </ul>
  <div class="btnWrapper">
    <button :class="['small',{ 'openBtn':this.windowW > 768 }]" @click="catelogSwith">商品分類 <span :class="['arrow',{ 'open' : fixMenuSwitch == true}]"></span></button>
    <button @click="goTocatelog('top')" class="top">TOP <span class="arrow"></span></button>
  </div>
  <div
    id="mobileList"
    v-if="this.windowW <= 768">
    選購清單({{cartLen()}}) <span @click="shopListSwith" v-if="!shopList && cartNoGiftLen > 0" style="cursor:pointer;color:#558fff">查看</span>
    <div
      :class="['order',{'emptyCart': cartNoGiftLen == 0}]"
      @click="toCart">結帳</div>
  </div>

</div>
</template>

<script>
import productBuy from "./productBuy.vue";
import productBuyM from "./productBuyM.vue";
const isMobile = /mobi(le)?/i.test(navigator.userAgent)
export default {
  name: "fixMenu",
  data() {
    return {
      showOverlay: false,
      selectedIndex: null,
      windowW: 0,
      fixMenuSwitch: false,
      isStopScrolling: false,
      cartList: [],
      cartNoGiftLen: 0,
      pageNo: 1,
      additionInfo: {},
      shopList: false,
      fixCartTop: isMobile ? 'unset' : '20px'
    }
  },
  components: {
    productBuy,
    productBuyM
  },
  props: {
    scrollY: {
      type: Number,
      defaults: 0,
    },
    category: {
      type: Array,
      default: () => []
    },
    itemAll: {
      type: Object,
      default: () => {}
    },
    isAddCart: {
      type: Boolean,
      default: false
    }
  },
  created() {
    // process temp cart
    const tempCartType = this.storage.get('tempCartType', true)
    const tempCart = this.storage.get('tempCart', true)
    const ticket = this.ec.getTicket()
    if (ticket) {
      if (tempCartType && tempCart) {
        this.ec.addToCart(tempCart).then(() => {
          this.storage.set("transactionCartType", tempCartType, this.configs.webCacheExpireTime);
          const message = new this.fridayMessage({
            name: 'add-to-cart',
            type: 'success',
            message: '商品加入選購清單成功',
            className: 'friday'
          })
          message.init()
          message.show()
          this.getCart()
        }).catch(data => {
          const message = new this.fridayMessage({
            name: 'add-to-cart',
            type: 'warning',
            message: `商品加入選購清單失敗,${data.payload.errorUiMsg}`,
            className: 'friday'
          })
          message.init()
          message.show()
        })
        this.storage.del('tempCartType', true)
        this.storage.del('tempCart', true)
      } else {
        this.getCart()
      }
    }

  },
  mounted() {
    this.rwdjudge();
    window.onresize = () => {
      this.rwdjudge();
    }
  },
  watch: {
    scrollY() {
      if (!isMobile) {
        const yGap = 35
        this.fixCartTop = this.scrollY >= yGap ? (this.scrollY - yGap) + 'px' : '20px';
      }

      const catelogs = document.querySelectorAll('.catalog')
      let bestCatalogTop = '';
      catelogs.forEach((catelog, i) => {
        const catelogTop = catelog.offsetTop;
        if (i == 0) {
          bestCatalogTop = catelogTop;
        }
        if (this.scrollY > catelogTop - window.screen.height / 2) {
          this.selectedIndex = i
        }
      })
      if (this.scrollY < bestCatalogTop) {
        this.selectedIndex = null
      }
      if (this.windowW > 768) {
        if (this.scrollY > 0) {
          document.querySelector('.top').className = 'top show'
        } else {
          document.querySelector('.top').className = 'top'
        }
      } else {
        let fixMenuBtn = document.querySelectorAll("#fixMenu>.btnWrapper button");
        if (this.scrollY > 0) {
          fixMenuBtn.forEach(btn => {
            if (btn.textContent.indexOf('商品分類') > -1) {
              btn.className = 'small'
            } else {
              btn.className = 'small top show'
            }
          })
        }
      }
    },
    itemAll: {
      handler(n) {
        if (Object.keys(n).length > 0) {
          this.itemAllf()
        }
      },
      deep: true,
      immediate: true,
    },
    isAddCart() {
      this.addCartF();
    },
    cartList() {
      this.$emit('getCartItems', this.cartList)
    }
  },
  computed: {
    cartLen() {
      return function () {
        let cartNoGiftAty = [];
        this.cartList.forEach(list => {
          if (list.ptype != 4) {
            cartNoGiftAty.push(list)
          }
        })
        this.cartNoGiftLen = cartNoGiftAty.length
        return this.cartNoGiftLen
      }
    }
  },
  methods: {
    catelogSwith() {
      this.fixMenuSwitch = !this.fixMenuSwitch
      this.showOverlay = !this.showOverlay
    },
    shopListSwith() {
      this.shopList = !this.shopList
      this.pageNo = 1
      this.showOverlay = !this.showOverlay
      if (this.windowW <= 768) {
        const body = document.querySelector("html");
        body.style = "padding:0;margin:0;overflow:hidden;height:100%";
        this.isStopScrolling = !this.isStopScrolling;
      }
    },
    passPageNow(page) {
      this.pageNo = page
    },
    nextPage() {
      this.pageNo = this.pageNo + 1
    },
    prevPage() {
      this.pageNo = this.pageNo - 1
    },
    getCart() {
      const ticket = this.ec.getTicket()
      if (ticket) {
        this.axios.get('getAllShoppingCartVO', {
          headers: {
            'authorization': 'Bearer' + ticket
          }
        }).then(res => {
          const data = res.data.payload

          if (data && data.shoppingCartVOList) {
            this.cartList = []
            data.shoppingCartVOList.forEach(item => {
              item.shoppingItems.forEach(shoppingItems => {
                this.cartList.push({
                  cpid: shoppingItems.categoryId.toString() + shoppingItems.productId.toString(),
                  cartid: item.cartId,
                  cid: shoppingItems.categoryId,
                  pid: shoppingItems.productId,
                  ptype: shoppingItems.productType,
                  specid: shoppingItems.specId,
                  qty: shoppingItems.quantity
                })
              })
            })

            if (this.cartList.length === 0) {
              this.showOverlay = false
              return
            }

            const batchPayload = this.cartList.map(v => {
              return {
                pid: v.pid,
                cid: v.cid
              }
            })

            this.axios
              .post(`api/product/search/batch`, batchPayload)
              .then(res => {
                parseAPI(res.data.payload[0].products)
              })

            const parseAPI = (payload) => {
              this.cartList.forEach((list, listIndex) => {
                if (payload[listIndex].pid === list.pid) {
                  const data = payload[listIndex]
                  if (data.additional && data.additional.length > 0) {
                    this.additionInfo = data.additional.filter(
                      (additional) => additional.max_qty > 0
                    )

                    this.additionInfo.forEach(addItem => {
                      const cpid = list.cid.toString() + addItem.aid.toString()
                      this.$set(this.itemAll, cpid, {
                        name: addItem.name,
                        imageurl: addItem.image_url,
                        carttype: data.cart_type
                      })
                    })
                  } else {
                    this.$set(this.cartList, listIndex, Object.assign(list, {
                      name: data.name,
                      imageurl: data.image_url,
                      carttype: data.cart_type
                    }))
                  }
                }
              })
            }
          }

          this.itemAllf()
          this.isAddCart = false
          this.$emit("finishaddcart")
        })
      }
    },
    itemAllf() {
      this.cartList.forEach((list, index) => {
        this.$set(this.cartList, index, Object.assign({}, list, this.itemAll[list.cpid]))
      })
    },
    addCartF() {
      this.getCart()
    },
    deleteCart() {
      this.getCart();
    },
    overlay() {
      this.showOverlay = false
      this.shopList = false
      if (this.windowW <= 768) {
        this.fixMenuSwitch = false
        const body = document.querySelector("html");
        body.style = "padding:0;margin:0;";
        this.isStopScrolling = !this.isStopScrolling;
      }
    },
    close() {
      this.$emit("closeDetail");
    },
    goTocatelog(i) {
      if (i === 'top') {
        if (this.windowW <= 768) {
          this.fixMenuSwitch = false;
          this.shopList = false;
          this.showOverlay = false
        }
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        })
        this.selectedIndex = null;
      } else {
        this.selectedIndex = i;
        if (this.windowW <= 768) {
          this.fixMenuSwitch = false;
        }
        this.$emit('catalogNum', i)
        this.showOverlay = false
      }
    },
    rwdjudge() {
      this.windowW = window.innerWidth;
      const fixMenu = document.querySelector("#fixMenu");
      const fixMenuLogo = document.querySelector("#fixMenu .imgWrapper");
      const fixMenuLi = document.querySelectorAll("#fixMenu li");
      const arrowArea = document.querySelector("#arrowArea");
      const listWrapper = document.querySelector("#listWrapper .box");
      let fixMenuBtn = document.querySelectorAll("#fixMenu>.btnWrapper button");
      if (this.windowW <= 768) {
        arrowArea.style.display = 'none';
        fixMenuLogo.style.display = 'none';
        listWrapper.style.display = 'none';
        fixMenu.style.bottom = '0';
        fixMenu.style.width = '100%';

        fixMenuLi.forEach(li => {
          li.className = 'small';
        });
        fixMenuBtn.forEach(btn => {
          btn.className = 'small top show'
        })
        this.fixMenuSwitch = false
      } else {
        arrowArea.style.display = 'block';
        fixMenuLogo.style.display = 'block';
        listWrapper.style.display = 'block';
        fixMenu.style.bottom = 'unset';
        fixMenu.style.width = '';

        fixMenuLi.forEach(li => {
          li.className = '';
        })
        fixMenuBtn.forEach(btn => {
          if (btn.textContent.indexOf('商品分類') > -1) {
            btn.className = 'openBtn'
          } else {
            if (this.scrollY > 0) {
              btn.className = 'top show'
            }
            btn.className = 'top'
          }
        });
        this.fixMenuSwitch = true
      }
      this.showOverlay = false
    },
    stopBodyScroll(action) {
      const body = document.querySelector("html");
      if (!this.isStopScrolling) {
        body.style = "padding:0;margin:0;overflow:hidden;height:100%";
        this.isStopScrolling = !this.isStopScrolling;
      }

      if (action === "close") {
        body.style = "padding:0;margin:0;overflow-x:hidden";
        this.isStopScrolling = false;
      }
    },
    toCart() {
      if (this.cartList.length == 0) {
        return
      }
      let cartTypeAry = []
      let cartType = ''
      this.cartList.forEach(list => {
        cartTypeAry.push(list.carttype)
      })
      cartType = cartTypeAry.find(list => {
        return list
      })

      if (this.isMobile) {
        window.location.href =
          `/mobileweb/checkout/step1?cartType=${cartType}`;
      } else {
        window.location.href =
          `/ec2/shoppingcart?cartType=${cartType}`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../style/icon.scss";

#fixMenu {
  position: absolute;
  right: -140px;
  top: 20px;
  z-index: 1;
  transition: .7s;
  transform: translateZ(0);

  .imgWrapper {
    width: 110px;
    height: 24px;
    background: url(../../assets/friday@2x.png) no-repeat;
    background-size: cover;
    margin: 0 auto;
  }

  ul {
    width: 120px;
    color: #fff;
    text-align: center;
    background-color: #3c3c3c;
    overflow: hidden;

    @media(max-width:768px) {
      width: 100%;
      position: relative;
      z-index: 101;
    }

    li {
      border-top: 1px solid #fff;
      background-color: #3c3c3c;
      padding: 10px;
      text-align: center;
      font-size: .875rem;
      cursor: pointer;
      transition: .3s;

      &.small {
        display: inline-block;
        text-align: left;
        width: 100%;
        margin: 0;
        border: none;
        padding-left: 25px;
        background-color: #fff;
        color: #3c3c3c
      }

      @media(min-width:768px) {
        &:hover {
          background-color: #60ba9a;
          color: #fff
        }
      }

      &.active {
        background-color: #60ba9a;
        color: #fff
      }

    }
  }

  .btnWrapper {
    display: flex;

    @media(max-width:768px) {
      background-color: #fff;
      position: relative;
      z-index: 101;
    }

    button {
      border-top: 1px solid #fff;
      background-color: #3c3c3c;
      padding: 10px 0;
      font-size: .875rem;
      cursor: pointer;
      width: 100%;
      color: #fff;
      border-radius: 0 0 10px 10px;
      z-index: -1;

      span.arrow {
        background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAYCAYAAADkgu3FAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAGqADAAQAAAABAAAAGAAAAAA2CeVqAAABTklEQVRIDe2Uu0oDYRCF12tULHwbEUIEQbDwEbSwsEghaEIQsVCwsUghWOQFAgkpIoKFIAgi+DwqXgtdvwnZZTL77w3SuT8c9szMOWfCn2w8rzjFDeS9Ad/3F8EVeAVNMJE3I1VP6AJ4APq0KMa3jLB5cK83KH6Z+imzCAicA3cq2EUvsmTFakgsgVuT/Ex9Cn5MvxkblDQgZBbcmLAX6mXx8dwGdtl5UmZkRsAMuAb6yC9tRYupd8CvFsHPtCaWI5wGfWN+oy67TPR3gV124tKGPQxToAf0eadYDUUOwryqDUN+7JAO7lyWdIzhg3rNaTBNdHvGK+XhiIzGJGjLRJ1P+PqIMKVAf6D8Aa2HNjpbQXf4/OK5EQpyEHwNkyVlZRAB2VfDb/hmjuyIFP+RyhNaDRbJn2UXPIFM30kk3TTIqQF5uR/BkhkX5X+/gT+hti6KFYH1AwAAAABJRU5ErkJggg==');
        width: 12px;
        height: 12px;
        display: inline-block;
        background-repeat: no-repeat;
        background-size: contain;
        transition: .3s;

        &.open {
          transform: rotate(180deg);
        }
      }

      &.openBtn {
        display: none;
      }

      &.top {
        transform: translate(0, -100%);
        opacity: 0;
        transition: .3s;
      }

      &.show {
        opacity: 1;
        transform: translate(0, 0);
        z-index: 0
      }

      &.small {
        width: 49.9%;
        margin: 0 .05%;
        border-radius: 0;
        border: 1px solid #fff;
        z-index: 0
      }
    }
  }

  #listWrapper {
    position: relative;
    z-index: 101;
    bottom: 0;

    #listContainer {
      background-color: #fff;
      max-height: 750px;

      h2 {
        text-align: center;
        padding: 10px 0;
        border-bottom: 1px solid #e0e0e0;
        font-size: 1.125rem;
      }
    }

    .close {
      width: 45px;
      height: 45px;
      position: absolute;
      top: 0;
      right: 140px;
      z-index: 102;

      @media(max-width:768px) {
        right: 0;
      }
    }

    .list {
      background-color: #fff;
      height: 365px;
      max-width: 950px;
      right: 131px;
      top: 0;
      position: absolute;
      border-radius: 10px 0 10px 10px;

      @media(max-width:768px) {
        max-width: none;
        position: relative;
        border-radius: 0;
        bottom: 0;
        top: unset;
        right: 0;
        width: 100%;
        max-height: calc(100vh - 40vh);
        height: auto;
        overflow-y: scroll;
      }

      .pagination {
        position: absolute;
        bottom: 0;
        right: 20px;

        button {
          padding: 5px;
          width: 25px;
          height: 25px;
          margin-bottom: 10px;
          margin-right: 15px;
          border: 1px solid rgba(0, 0, 0, 0.3);
          background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKKADAAQAAAABAAAAKAAAAAB65masAAABfUlEQVRYCe3WsWqEQBAA0DOKv5ArwkVCinyE4AZt8gUpUuc//JGQInXaVOLZXHmQD7jCg/uAHFyjKGYGEhAJmBlntkjcamVnd5+jMLNYzGPOwD/JQBzH51EU3aVpekZ5ZVIw5eB+rDHmpq7r97Zt3/I8N/21sbk6EHEAW3ddt3QcZ+f7/nYM1V9XBQ5xruveZll27APG5s5YAHf9J1xRFAfqeSpAKRy+jDhQEicOlMaJAjVwYkAtnAhQEzcZqI2bBLSBYwNt4VhAmzgyMAzDKyj4m+/Cj7WVU77w4t8OUrMAuAfE4eGAe9TG4T0kIKCeYc8eN0IL9QKf+xrnmoMExIx5nmcAtIdMXmCfp41kNQuACpqmKQB6CZ/98PUv7uBZfLCAqLCFZANtIScBbSAnA7WRIkBNpBhQCykK1ECKA6WRKkBJpBpQCkmqxXgpZUDtLoe1O0mSFeUMVSBChsiqqu4pQJcSzI0ty/IjCIJX2H+CxuIJnk/cs+Z9fy4Dn808TWpYtLYqAAAAAElFTkSuQmCC);
          background-size: contain;
          border-radius: 5px;

          &.nextBtn {
            transform: rotate(-180deg);
            margin-bottom: 15px;
            margin-right: 0;
            margin-left: 15px;
          }
        }
      }
    }

    .productWrapper {
      display: flex;
      padding: 45px 20px;
      width: 100%;
      box-sizing: border-box;

      @media(max-width:768px) {
        flex-wrap: wrap;
        padding: 10px 15px;
      }

      div {
        @media(max-width:768px) {
          width: 100%;
        }
      }
    }

    .box {
      border-radius: 10px 10px 0 0;
      background-color: #fff;
      width: 120px;
      height: 116px;
      padding: 10px 0;

      .switchBtn {
        position: absolute;
        left: 5px;
        top: 50%;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAKKADAAQAAAABAAAAKAAAAAB65masAAABfUlEQVRYCe3WsWqEQBAA0DOKv5ArwkVCinyE4AZt8gUpUuc//JGQInXaVOLZXHmQD7jCg/uAHFyjKGYGEhAJmBlntkjcamVnd5+jMLNYzGPOwD/JQBzH51EU3aVpekZ5ZVIw5eB+rDHmpq7r97Zt3/I8N/21sbk6EHEAW3ddt3QcZ+f7/nYM1V9XBQ5xruveZll27APG5s5YAHf9J1xRFAfqeSpAKRy+jDhQEicOlMaJAjVwYkAtnAhQEzcZqI2bBLSBYwNt4VhAmzgyMAzDKyj4m+/Cj7WVU77w4t8OUrMAuAfE4eGAe9TG4T0kIKCeYc8eN0IL9QKf+xrnmoMExIx5nmcAtIdMXmCfp41kNQuACpqmKQB6CZ/98PUv7uBZfLCAqLCFZANtIScBbSAnA7WRIkBNpBhQCykK1ECKA6WRKkBJpBpQCkmqxXgpZUDtLoe1O0mSFeUMVSBChsiqqu4pQJcSzI0ty/IjCIJX2H+CxuIJnk/cs+Z9fy4Dn808TWpYtLYqAAAAAElFTkSuQmCC");
        background-size: cover;
        cursor: pointer;
      }

      img {
        // width: 100%;
        width: 50px;
        height: 50px;
        margin: 10px auto;
      }

      h2 {
        text-align: center;
        font-size: .875rem;
      }

      .order {
        width: 68px;
        border-radius: 10px;
        margin: 0 auto;
        padding: 5px 0;
        text-align: center;
        background-color: #f34f59;
        color: #fff;
        cursor: pointer;
        font-size: .875rem;

        &.emptyCart {
          background-color: #e0e0e0;
          cursor: not-allowed;
        }
      }
    }
  }

  #mobileList {
    background-color: #fff;
    padding: 15px 13px;
    z-index: 101;
    border-top: 1px solid #e0e0e0;

    @media(max-width:768px) {
      position: relative;
      bottom: 0;
      top: unset;
      right: 0;
    }

    .order {
      position: absolute;
      right: 10px;
      top: 10px;
      width: 100px;
      padding: 5px 0;
      border-radius: 10px;
      text-align: center;
      background-color: #f34f59;
      color: #fff;
      cursor: pointer;
      font-size: .875rem;

      &.emptyCart {
        background-color: #e0e0e0;
        cursor: not-allowed;
      }
    }
  }
}

@media (max-width: 768px) {
  #fixMenu {
    position: fixed;
    left: 0;
    right: 0;
    top: unset;
    bottom: 0;
    z-index: 1;
    transition: .7s;
    transform: translateZ(0);
  }
}
</style>
